export var RateClassificationNames = function (RateClassificationNames) {
  RateClassificationNames["FLEXRATE"] = "Flex";
  RateClassificationNames["SEMIFLEX"] = "Semi-Flex";
  RateClassificationNames["STANDARD"] = "Standard";
  RateClassificationNames["ADVANCE"] = "Advance";
  RateClassificationNames["NONFLEX"] = "Non-Flex";
  return RateClassificationNames;
}({});